var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBathtub = function SvgIconBathtub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.506 4.256A.875.875 0 0 1 8 4.875a1 1 0 0 0 2 0 2.875 2.875 0 1 0-5.75 0V8.75h-2A1.75 1.75 0 0 0 .5 10.5v3a5.5 5.5 0 0 0 5.25 5.494v1.256a1 1 0 1 0 2 0V19h8.5v1.25a1 1 0 1 0 2 0v-1.256A5.5 5.5 0 0 0 23.5 13.5v-3a1.75 1.75 0 0 0-1.75-1.75h-2.032A1 1 0 0 0 18.75 8h-6a1 1 0 0 0-.969.75H6.25V4.875c0-.232.092-.455.256-.619m5.244 6.494H2.5v2.75A3.5 3.5 0 0 0 6 17h12a3.5 3.5 0 0 0 3.5-3.5v-2.75h-1.75v2.75a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm2-.75v2.5h4V10z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBathtub;